module.exports = __webpack_public_path__ + "assets/img/network.ea7ee469.svg";